import { render, staticRenderFns } from "./NpsChartClient.vue?vue&type=template&id=56c63218"
import script from "./NpsChartClient.vue?vue&type=script&lang=js"
export * from "./NpsChartClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports